import Nelson from './Nelson'

const Splash = ({ onScreenUpdate }) => {
  const onGo = () => {
    onScreenUpdate('welcome')
  }

  return (
    <div className="splash">
      <div className="logoBox">
        <img
          className="logo"
          src="images/launchPage_logo.png"
          alt="Equine Science 4 Kids Logo - contains golden horseshoe with a molecule in the center of the horseshoe."
        />
      </div>
      <button onClick={onGo}>
        <img src="images/go_btn.png" alt="Go"></img>
      </button>
      <p>
        By clicking “Go” you agree to the Terms and Conditions of Use for
        EquineScience4Kids!
        <br />
        <a href="pages/main/terms.html" target="_blank" rel="noreferrer">
          Read our Terms and Conditions of Use.
        </a>
      </p>
      <Nelson />
    </div>
  )
}

export default Splash
